import {classes} from '@bitstillery/common/lib/utils'
import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'

interface ButtonGroupAttrs {
    className?: string
    type?: string
}

export class ButtonGroup extends MithrilComponent<ButtonGroupAttrs> {
    view(vn: m.Vnode<ButtonGroupAttrs>) {
        return (
            <div
                className={classes(
                    'c-button-group',
                    vn.attrs.className,
                    vn.attrs.type ? `type-${vn.attrs.type}` : 'type-default',
                )}
            >
                {vn.children}
            </div>
        )
    }
}
